import React, { useEffect, useState } from "react";
import { Message } from "semantic-ui-react";
import { ResumenVecino } from "../../components/Vecino/ResumenVecino";
import { ItemLista } from "../../components/Solicitud/ItemLista";
import { Derivaciones } from "../../components/Solicitud/Derivaciones";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../components/Otros/LoadingSpinner";
import { anularSolicitud, listarAntecedentes, verSolicitud } from "../../utils/Datos";
import Swal from "sweetalert2";
import { fechaHumana } from "../../utils/Util";
import { Estados } from "../../components/Otros/Estados";
import { BotonArchivo } from "../../components/Otros/BotonArchivo";
import { Header, Modal } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { selectUser } from "../../reducers/userSlice";
import SatisfactionSurveyBanner from "../../components/Otros/SatisfactionSurveyBanner";

export const VerSolicitud = () => {
  const error = localStorage.getItem("error");
  const info = localStorage.getItem("info");
  const exito = localStorage.getItem("exito");

  const [open, setOpen] = useState(false);

  const { id_request_neighbor } = useParams();
  const [solicitud, setsolicitud] = useState(null);
  const [cargando, setcargando] = useState(true);
  const [antecedentes, setantecedentes] = useState([]);
  const [comentario, setcomentario] = useState(null);
  const user = useSelector(selectUser);

  const handleAnular = ()=>{
    let payload={
      comment : comentario,
      id_request_neighbor : solicitud.id_request_neighbor,
      user_session : user.user.run
    }
    anularSolicitud(payload).then((respuesta)=>{
      if (respuesta.status) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: "Solicitud anulada con éxito",
        }).then((okay) => {
          document.getElementById("closeModal").click();
          if (okay) {
            window.location.href = "/home";
          }
        });

      }else{
        Swal.fire({
          icon:'error',
          title:'Error',
          text:respuesta.errores[0]
        })

      }
    })

  }

  useEffect(() => {
    verSolicitud(id_request_neighbor).then((resultado) => {
      if (resultado.status) {
        setcargando(false);
        setsolicitud(resultado.datos);
      } else {
        setcargando(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            "Ha ocurrido un error al cargar esta solicitud: " +
            resultado.errores[0],
        }).then((okay) => {
          if (okay) {
            window.location.href = "/home";
          }
        });
      }
    });

    listarAntecedentes(id_request_neighbor).then((resultado) => {
      if (resultado.status) {
        setantecedentes(resultado.datos);
      } else {
      }
    });
  }, []);




  return (
    <div className="container post">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <ResumenVecino></ResumenVecino>

              <SatisfactionSurveyBanner></SatisfactionSurveyBanner>

              {cargando ? (
                <LoadingSpinner texto={`Cargando solicitud...`} />
              ) : solicitud != null ? (
                <div className="card card-bordered w-100 mt-10">
                  <div className="card-body">
                    <h1 className="text-gray-700 mb-10">
                    <span className="badge badge-info badge-lg me-4" style={{fontSize:18}}><b>ID: {solicitud.id_request_neighbor}</b> </span> Título: {solicitud.title}
                    </h1>
                    <div className="row border-bottom mt-6 pb-4 mt-10">
                      <div className="mb-4 col-md-4">

                        <div className="row me-10">
                          <div className="col-4 fw-bold fs-5 lh-lg mb-4">
                            Temas
                          </div>
                          <div className="col fs-5 lh-lg text-start ms-4">
                            {solicitud.request_thematics.map((tema, index) => {
                              return (
                                <div key={index}>
                                  <span className="badge badge-primary me-2">
                                    {tema.thematic.name_thematic}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="mb-4 col-md-4">
                        <div className="row me-10">
                          <div className="col-4 fw-bold fs-5 lh-lg">
                            Creado el
                          </div>
                          <div className="col fs-5 lh-lg ms-4 mb-4 text-muted">
                            {fechaHumana(solicitud.created_date)}
                          </div>
                        </div>
                      </div>
                      <div className="mb-4 col-md-4">
                        <div className="row me-10">
                          <div className="col-4 fw-bold fs-5 lh-lg">Estado</div>
                          <div className="col fs-5 lh-lg text-start ms-4">
                            {<Estados estado={solicitud.state} />}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body row">
                    <div className="mb-0 col-12">
                      <h4 className="text-gray-700">Detalle</h4>
                      <textarea
                        name="notes"
                        className="form-control  "
                        rows="6"
                        placeholder=""
                        defaultValue={solicitud.details}
                        readOnly
                      ></textarea>
                    </div>
                    {antecedentes.length > 0 ? (
                      <div className="mb-0 mt-5 col-12">
                        <h4 className="text-gray-700">Archivos adjuntos</h4>

                        {antecedentes.length > 0 ? (
                          antecedentes.map((documento, index) => {
                            return (
                              <BotonArchivo documento={documento}></BotonArchivo>
                            );
                          })
                        ) : (
                          <>No se encontraron antecedentes</>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="card-body">
                    <Derivaciones
                      titulo={solicitud.title}
                      id_request_neighbor={solicitud.id_request_neighbor}
                    ></Derivaciones>
                  </div>

                  <div className="card-footer row">
                      <div className="col-md-12">
                        {
                          solicitud.state=="EN PROCESO" || solicitud.state=="SIN ASIGNAR" &&
                          <button
                            type="button"
                            className="btn btn-danger btn-lg"
                            data-bs-toggle="modal"
                            data-bs-target="#modalAnular"
                          >
                            <i className="fas fa-times mr-2"></i>Anular solicitud
                          </button>
                        }



                        <div
                          className="modal fade"
                          id="modalAnular"
                          tabindex="-1"
                          data-bs-backdrop="static"
                          data-bs-keyboard="false"

                          role="dialog"
                          aria-labelledby="modalTitleId"
                          aria-hidden="true"
                        >
                          <div
                            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title" id="modalTitleId">
                                  Anular solicitud
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                  id="closeModal"
                                ></button>
                              </div>
                              <div className="modal-body">
                                <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">Ingresa un comentario para anular esta solicitud</label>
                                <textarea onChange={(e)=>{setcomentario(e.target.value)}} className="form-control"></textarea>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                >
                                  Cancelar
                                </button>
                                <button type="button" className="btn btn-danger" onClick={handleAnular}>Confirmo que anularé</button>
                              </div>
                            </div>
                          </div>
                        </div>



                      </div>
                  </div>
                </div>
              ) : (
                <div className="alert alert-warning" role="alert">
                  <strong>No existe la solicitud</strong>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
